import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Files } from "../../services/FilesService";
import RichTextViewer from "../RichTextArea/RichTextViewer";

const PublicTextArea = ({ id, label, type, tenantId }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    Files.getPublicFileContent("response.html", type, id, tenantId).then(
      (res) => {
        setContent(res.content);
      }
    );
  }, [type, id, tenantId]);

  return content !== null ? (
    <RichTextViewer id={id} label={label} value={content} />
  ) : (
    <Skeleton height="10rem" />
  );
};
export default PublicTextArea;
